export enum PageAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}
